module.exports = __webpack_public_path__ + "static/media/happy.a98fe520.png";